import { render, staticRenderFns } from "./MegaMenuCategoryColumn.vue?vue&type=template&id=ceb5e2c4&scoped=true"
import script from "./MegaMenuCategoryColumn.vue?vue&type=script&lang=js"
export * from "./MegaMenuCategoryColumn.vue?vue&type=script&lang=js"
import style0 from "./MegaMenuCategoryColumn.vue?vue&type=style&index=0&id=ceb5e2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb5e2c4",
  null
  
)

export default component.exports